import { render, staticRenderFns } from "./NormocasOdpis.vue?vue&type=template&id=47c4cd08&"
import script from "./NormocasOdpis.vue?vue&type=script&lang=ts&"
export * from "./NormocasOdpis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports